import { ButtonVariant } from "@src/shared/button/Button";
import { StyledButtonSpan } from "@src/shared/button/StyledButtonSpan";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import styled from "styled-components";

export const SkipLinks = () => {
    const intl = useIntl();

    return (
        <nav
            aria-label={intl.formatMessage({
                defaultMessage: "Skip links",
                id: "leaseme.skipLinks.ariaLabel",
            })}
        >
            <SkipLink href="#mainContent">
                <StyledButtonSpan variant={ButtonVariant.Gray}>
                    <FormattedMessage id="leaseme.skipLink.mainContent" defaultMessage="Zum Hauptinhalt springen" />
                </StyledButtonSpan>
            </SkipLink>
            <SkipLink href="#mainFooter">
                <StyledButtonSpan variant={ButtonVariant.Gray}>
                    <FormattedMessage id="leaseme.skipLink.footerContent" defaultMessage="Zum Footer springen" />
                </StyledButtonSpan>
            </SkipLink>
        </nav>
    );
};

const SkipLink = styled.a`
    position: absolute;
    top: 100px;
    left: 20px;
    z-index: 5000000000;
    display: flex;

    /* Hide the skip link visually but keep it accessible for screen readers */
    height: 1px;
    width: 1px;
    overflow: hidden;
    white-space: nowrap;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);

    opacity: 0;
    text-decoration: none;
    pointer-events: none;

    &:focus {
        opacity: 1;
        outline: 2px solid ${({ theme }) => theme.colors.darkRed};
        outline-offset: 1px;
        height: auto;
        width: auto;
        clip: auto;
        clip-path: none;
        pointer-events: auto;
    }
`;
